import { reportEvent } from "@/api";
import { ReportTargetMap } from "@/config";
import {
  openLowPaymentOffersPage,
  openNGLowPaymentOffersPage,
  openPKLowPaymentOffersPage,
} from "@/views/main/activity/christmas/config";

/*印度 美国 巴西 None 巴基斯坦 法国 土耳其 埃及 阿联酋 沙特阿拉伯 尼日利亚 孟加拉国 罗马尼亚 英国 加拿大 肯尼亚 印度尼西亚 德国 菲律宾 马来西亚 葡萄牙 新加坡 墨西哥 越南 秘鲁 摩洛哥 日本 黎巴嫩 意大利 西班牙 哥伦比亚 俄罗斯联邦 阿根廷 澳大利亚 约旦 智利 荷兰 波兰 塞尔维亚 捷克 突尼斯 韩国 马达加斯加 厄瓜多尔 南非 瑞士 阿尔及利亚 巴拿马 以色列 比利时 卡塔尔 伊朗 乌克兰 瑞典 立陶宛 亚美尼亚 匈牙利 尼泊尔 安哥拉 丹麦 保加利亚 埃塞俄比亚 希腊 乌兹别克斯坦 爱尔兰 阿塞拜疆 津巴布韦 加纳 乌干达 哈萨克斯坦 阿曼 坦桑尼亚 毛里求斯 马其顿 委内瑞拉 格鲁吉亚 卢旺达 阿尔巴尼亚 喀麦隆 白俄罗斯 挪威 莫桑比克 塞浦路斯 哥斯达黎加 克罗地亚 科特迪瓦 多米尼加 奥地利 斯里兰卡 塞内加尔 新西兰 拉脱维亚 波黑 芬兰 摩尔多瓦 爱沙尼亚 科威特 卢森堡 伊拉克 斯洛伐克 刚果(金 阿富汗 特立尼达和多巴哥 危地马拉 巴林 斯洛文尼亚 玻利维亚 塞舌尔 贝宁 马里 乌拉圭 尼加拉瓜 巴布亚新几内亚 多哥 吉尔吉斯斯坦 马耳他 巴勒斯坦 布基纳法索 也门 巴拉圭 吉布提 牙买加 老挝 博茨瓦纳 利比亚 纳米比亚 赞比亚 黑山 洪都拉斯 叙利亚 加蓬 刚果(布 几内亚 斐济 布隆迪 苏里南 萨尔瓦多 马尔代夫 巴巴多斯 不丹 古巴 佛得角 塔吉克斯坦 毛里塔尼亚 斯威士兰 莱索托 蒙古 马拉维 利比里亚 南苏丹 冈比亚 乍得 厄立特里亚 圣文森特和格林纳丁斯 波多黎各 留尼汪 直布罗陀 苏丹 赤道几内亚 圭亚那 圣基茨和尼维斯 百慕大 阿鲁巴*/
const contryCodeMap: Record<string, string> = {
  中国: "CN",
  印度: "IN",
  巴基斯坦: "PK",
  尼日利亚: "NG",
};
export function getCountryCodeByName(countryName?: string) {
  if (!countryName) {
    return;
  }
  return contryCodeMap[countryName];
}
export const lowPaymentCountryInfo = (ver: string) => ({
  IN: {
    trackEvent: `billing_v${ver}_india_offer_show`,
    copywriting: "🇮🇳 Enter India Exclusive Offer · Pay with UPI",
    onClick() {
      reportEvent({
        event: "click",
        target: ReportTargetMap[`billing_v${ver}_india_offer_click`],
      });
      openLowPaymentOffersPage();
    },
  },
  PK: {
    trackEvent: `billing_v${ver}_pakistan_offer_show`,
    copywriting: "🇵🇰 Click to Enter Exclusive Pakistan Offer",
    onClick() {
      reportEvent({
        event: "click",
        target: ReportTargetMap[`billing_v${ver}_pakistan_offer_click`],
      });
      openPKLowPaymentOffersPage();
    },
  },
  NG: {
    trackEvent: `billing_v${ver}_nigeria_offer_show`,
    copywriting: "🇳🇬 Click to Enter Exclusive Nigeria Offer",
    onClick() {
      reportEvent({
        event: "click",
        target: ReportTargetMap[`billing_v${ver}_nigeria_offer_click`],
      });
      openNGLowPaymentOffersPage();
    },
  },
});
